export default [
  {
    path: "/point-exchange/upload-point/upload-point-list",
    name: "upload-point-list",
    component: () =>
      import(
        "@/views/pages/ais-point/upload-point/upload-point-list/UploadPointList.vue"
      ),
    meta: {},
    breadcrumb: [
      {
        text: "Point Exchange",
      },
      {
        text: "Campaign List",
        active: true,
      },
    ],
  },
  {
    path: "/point-exchange/upload-point/upload-point-create",
    name: "upload-point-create",
    component: () =>
      import(
        "@/views/pages/ais-point/upload-point/upload-point-info/UploadPointInfo.vue"
      ),
    meta: {},
    breadcrumb: [
      {
        text: "Point Exchange",
      },
      {
        text: "Campaign List",
        active: true,
      },
      {
        text: "Upload Point",
        active: true,
      },
    ],
  },
  {
    path: "/point-exchange/upload-point/upload-point-info/:id",
    name: "upload-point-info",
    component: () =>
      import(
        "@/views/pages/ais-point/upload-point/upload-point-info/UploadPointInfo.vue"
      ),
    meta: {},
    breadcrumb: [
      {
        text: "Point Exchange",
      },
      {
        text: "Campaign List",
        active: true,
      },
      {
        text: "Upload Point",
        active: true,
      },
    ],
  },
];
